import React, {Component} from 'react';
import '../../../css/add-new-route/styles.scss';
import BasicSettings from "./BasicSettings/BasicSettings";
import Endpoints from "./Endpoints/Endpoint/Endpoints";
import CheckEmptyFields from "../../includes/CheckEmptyFields";
import { connect } from "react-redux";
import RouteHeader from "./routeHeader";
import {Notices} from "./Notices";
import {changeBasicFields, changeMainField, showCurrentRoute} from "../../store/actions/route";
import {updateCustomTables} from "../../store/actions/customTables";
import Switch from "react-switch";
import {endpointAddNew} from "../../store/actions/endpoints";

class CustomRoute extends Component {

	componentDidMount() {
		if ( typeof routeSettings !== 'undefined' ) {
			this.props.showCurrentRoute( routeSettings[0] );
			this.props.changeMainField( 'routeId', routeId.id );
		}

		this.fetchCustomTables();
	}

	fetchCustomTables() {
		fetch(wpApiSettings.root + 'rest-routes/v2/custom-tables/tables-full', {
			method:  'GET',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce':   wpApiSettings.nonce
			},
		})
		.then(response => response.json())
		.then(json => {
			this.props.updateCustomTables(json);
		})
	}

	fetchCustomTablesColumns(table) {
		fetch(wpApiSettings.root + `rest-routes/v2/custom-tables/tables/${table}`, {
			method:  'GET',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce':   wpApiSettings.nonce
			},
		})
		.then(response => response.json())
		.then(json => {
			this.props.updateCustomTables(json);
		})
	}

	saveRoute = () => {
		let emptyFields = this.getEmptyFields();

		if (emptyFields.length > 0) {
			window.scrollTo(0, 0);
			return;
		}

		this.props.changeMainField( 'saved', false );
		this.props.changeMainField( 'invalidRoute', false );
		this.props.changeMainField( 'saving', true );

		fetch(wpApiSettings.root + 'rest-routes/v2/routes', {
			method:  'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce':   wpApiSettings.nonce
			},
			body:    JSON.stringify({
																settings: this.props.settings,
																routeId:  this.props.routeId
															})
		})
			.then(response => {
				return response.json();
			})
			.then(json => {
				if ( ! json.success ) {
					this.props.changeMainField( 'invalidRoute', true );
					this.props.changeMainField( 'saving', false );
				} else {
					this.props.changeMainField( 'routeId', json.data.route_id );
					this.props.changeMainField( 'saving', false );
					this.props.changeMainField( 'saved', true );

					window.history.pushState(
						'editRoute',
						'Rest Routes',
						window.location.href.replace('rest-routes-add-new', `edit-rest-route&id=${json.data.route_id}`)
					);
				}

				window.scrollTo(0, 0);
			})
	};

	handleAddExistingMethod( method ) {
		let existingMethods = this.state.existingMethods;
		existingMethods.push( method );
		this.props.changeMainField('existingMethods', existingMethods);
	};

	getEmptyFields() {
		let emptyFields = CheckEmptyFields( this.props.requiredFields, this.props.settings );
		this.props.changeMainField( 'requiredEmptyFields', emptyFields.requiredEmptyFields );
		return emptyFields.requiredEmptyFields;
	}

	handleFieldChange = (e, field) => {
		let requiredEmptyFields = this.state.requiredEmptyFields.filter(el => {
			return el.field !== field;
		});

		this.setState({requiredEmptyFields: requiredEmptyFields});
		this.updateSetting(field, e.target.value);
	};

	handleAddEndpoint = ( endpoint ) => {
		const settings = this.state.settings;
		settings.endpoints.push( endpoint );
		this.setState({settings: settings});
	};

	handleAddNewParameter = (endpointId) => {
		const settings = this.state.settings;

		settings.endpoints[endpointId].parameters.push({ name: '', required: false, type: 'any', default: '' });
		this.setState({settings: settings});
	};

	updateSetting(field, value) {
		const settings = this.state.settings;
		settings[field] = value;
		this.setState({settings: settings});
	}

	handleParamRemove = (endpointId, paramId) => {
		const settings = this.state.settings;
		settings.endpoints[endpointId].parameters = settings.endpoints[endpointId].parameters.filter((el, index) => {
			return index !== paramId;
		});
		this.setState({settings: settings});
	};

	handleDeleteEndpoint = (endpoint, field) => {
		let endpoints = this.state.settings.endpoints.filter((el, index) => {
			return index !== field;
		});

		this.updateSetting('endpoints', endpoints);
	};

	handleEndpointSelectFieldChange = (event) => {
		const endpoints = this.state.settings.endpoints;
		const data = event.target.name.split('-');
		const endpointIndex = endpoints.findIndex((obj, index) => index == data[1]);
		endpoints[endpointIndex][data[0]] = event.target.value;

		if ( data[0] === 'method' ) {
			let existingMethods = this.state.existingMethods;
			existingMethods.push( event.target.value );
			this.setState({existingMethods: existingMethods});
		}

		this.updateSetting('endpoints', endpoints);
	};

	handleParamFieldChange = ( endpointId, paramId, field, value ) => {
		const endpoints = this.state.settings.endpoints;
		endpoints[endpointId].parameters[paramId][field] = value;
		this.updateSetting('endpoints', endpoints);
	};

	handleCreatePostFieldChange = ( endpointId, group, groupId, fieldIndex, value, currentPost, action = 'createPost', inputType ) => {
		const endpoints = this.state.settings.endpoints;

		if ( inputType === 'checkboxes' ) {
			if ( ! endpoints[ endpointId ][action][ currentPost ][ group ][ groupId ].fields[ fieldIndex ].value ) {
				endpoints[ endpointId ][action][ currentPost ][ group ][ groupId ].fields[ fieldIndex ].value = []
			}

			if ( -1 === endpoints[ endpointId ][action][ currentPost ][ group ][ groupId ].fields[ fieldIndex ].value.indexOf( value ) ) {
				endpoints[ endpointId ][action][ currentPost ][ group ][ groupId ].fields[ fieldIndex ].value.push( value );
			} else {
				endpoints[ endpointId ][action][ currentPost ][ group ][ groupId ].fields[ fieldIndex ].value = endpoints[ endpointId ][action][ currentPost ][ group ][ groupId ].fields[ fieldIndex ].value.filter( el => {
					return el !== value;
				});
			}

		} else {
			endpoints[ endpointId ][action][ currentPost ][ group ][ groupId ].fields[ fieldIndex ].value = value;
		}

		this.updateSetting('endpoints', endpoints);
	};

	handleCreatePostAddNewPost = ( endpointId, data ) => {
		const endpoints = this.state.settings.endpoints;
		endpoints[ endpointId ].createPost.push( data );
		this.updateSetting('endpoints', endpoints);
	};

	handleCreatePostFieldAdd = ( defaultField, endpointId, currentPost ) => {
		const endpoints = this.state.settings.endpoints;

		if ( endpoints[ endpointId ].createPost[ currentPost ].defaultFields.findIndex( el => el.name === defaultField[0].name ) !== -1 ) {
			return;
		}

		endpoints[ endpointId ].createPost[ currentPost ].defaultFields.push( defaultField[0] );

		this.updateSetting('endpoints', endpoints);
	};

	handleCreatePostAddNonDefaultField = ( data, endpointId, group, currentPost ) => {
		const endpoints = this.state.settings.endpoints;
		endpoints[ endpointId ].createPost[ currentPost ][ group ].push( data );
		this.updateSetting('endpoints', endpoints);
	};

	handleCreatePostFieldRemoval = ( endpointId, groupId, group, currentPost, action = 'createPost' ) => {
		const endpoints = this.state.settings.endpoints;
		endpoints[ endpointId ][action][ currentPost ][ group ] = endpoints[ endpointId ][action][ currentPost ][ group ].filter( ( el, index ) => index !== groupId );
		this.updateSetting('endpoints', endpoints);
	};

	handleCreatePostRemovePost = ( endpointId, currentPost ) => {
		const endpoints = this.state.settings.endpoints;
		endpoints[ endpointId ].createPost = endpoints[ endpointId ].createPost.filter( ( el, index ) => index !== currentPost );
		this.updateSetting('endpoints', endpoints);
	};

	getEndpointCreatePostFieldValue = ( endpointId, group, groupId, fieldIndex, currentItem, action, inputType, item = '' ) => {
		if ( inputType === 'checkboxes' ) {
			return -1 !== this.state.settings.endpoints[endpointId][action][currentItem][group][groupId].fields[fieldIndex].value.indexOf( typeof item === 'object' ? item.value : item );
		} else {
			return this.state.settings.endpoints[endpointId][action][currentItem][group][groupId] ? this.state.settings.endpoints[endpointId][action][currentItem][group][groupId].fields[fieldIndex].value : '';
		}
	};

	handleDisplayDataAddFilter = (endpointId, filter, current, group) => {
		const endpoints = this.state.settings.endpoints;
		endpoints[endpointId].displayData[0][group].push(filter[0]);
		this.updateSetting('endpoints', endpoints);
	};

	getDisplayDataSingleField = (endpointId, queryType = '', fieldName = 'mainRelationType' ) => {
		if ( queryType && queryType === 'taxonomy' ) {
			return this.state.settings.endpoints[endpointId].displayData[0].taxonomyRelationType;
		} else {
			return this.state.settings.endpoints[endpointId].displayData[0][fieldName];
		}
	};

	handleDisplayDataSingleField = (endpointId, value, fieldName = 'mainRelationType' ) => {
		const endpoints = this.state.settings.endpoints;
		endpoints[endpointId].displayData[0][fieldName] = value;
		this.updateSetting( 'endpoints', endpoints );
	};

	handleRouteSwitcher = ( checked ) => {
		this.updateSetting( 'enabled', checked );
	};

	handleEndpointSwitcher = ( e, endpointId ) => {
		const endpoints = this.state.settings.endpoints;
		endpoints[endpointId].enabled = e;
		this.updateSetting( 'endpoints', endpoints );
	};

	render() {
		return (
			<React.Fragment>
				<RouteHeader/>
				<Notices
					invalidRoute={this.props.invalidRoute}
					requiredEmptyFields={this.props.requiredEmptyFields}
					saved={this.props.saved}
					routeId={this.props.routeId}
				/>
				<p>Switch on/off the whole route</p>

				<div><Switch onChange={() => this.props.changeBasicFields( 'enabled', !this.props.settings.enabled )} checked={this.props.settings.enabled}/></div>
				<div>
					<BasicSettings/>

					<hr />
          <br />

          {
            !this.props.premium ?
              <div className="notice notice-info inline" style={{opacity: 1, display: 'block'}}><p>You are using a basic version of Rest Routes. Upgrade now for unlocking all the powerful features of Rest Routes Pro!</p></div>
              : ''
          }

					<Endpoints/>
					<div className="buttonsBottom">
						<button onClick={() => this.saveRoute()} className="button-primary" style={{marginRight: '10px'}}>Save</button>
						<button onClick={ () =>  this.props.endpointAddNew() } className="button-secondary">Add new endpoint</button>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	requiredFields: state.requiredFields,
	settings: state.settings,
	routeId: state.routeId,
	invalidRoute: state.invalidRoute,
	requiredEmptyFields: state.requiredEmptyFields,
	saved: state.saved,
  premium: state.premium
});

const mapDispatchToProps = dispatch => ({
	changeMainField: ( name, value ) => dispatch( changeMainField( name, value ) ),
	changeBasicFields: ( fieldName, fieldValue ) => dispatch( changeBasicFields( fieldName, fieldValue ) ),
	updateCustomTables: (value) => dispatch( updateCustomTables(value) ),
	showCurrentRoute: ( value ) => dispatch( showCurrentRoute( value ) ),
	endpointAddNew: () => dispatch( endpointAddNew() ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomRoute);
